import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { motion } from 'framer-motion';

// Note: In a real implementation, import Clerk components like this:
import { SignInButton, SignUpButton, useClerk, useUser } from '@clerk/clerk-react';

export default function SignInPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageLoaded, setPageLoaded] = useState(false);
  const { user } = useUser();
  // Get redirect URL from query params
  const searchParams = new URLSearchParams(location.search);
  const redirectUrl = searchParams.get('redirect_url') || '/';
  
  // Set page as loaded after a short delay for entrance animation
  useEffect(() => {
    setTimeout(() => {
      setPageLoaded(true);
    }, 300);
  }, []);
  

  
  return (
    <div className="min-h-screen">
      <Navbar /> 
      <main className="auth-page">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: pageLoaded ? 1 : 0, y: pageLoaded ? 0 : 20 }}
          transition={{ duration: 0.5 }}
          className="auth-container"
        >
          <h1 className="auth-title">Authentication Required</h1>
          
          {redirectUrl !== '/' && (
            <p className="redirect-notice">
              Please sign in or create an account to continue to checkout
            </p>
          )}
          
         
          
          
            {user ? (<> 
              <p className="redirect-notice">
                You are already signed in as {user.emailAddresses[0].emailAddress}
              </p>
              <button className="clerk-button sign-in" onClick={() => navigate(redirectUrl)}>
                Continue with checkout
              </button></>
            ) : (
              <>
            <SignInButton mode="modal" afterSignInUrl={redirectUrl}>
              <button className="clerk-button sign-in">
                Sign In 
              </button>
            </SignInButton>
            <br/>
            or
            <br/>
         
            
            <SignUpButton mode="modal" afterSignUpUrl={redirectUrl}>
              <button className="clerk-button sign-up">
                <strong>Sign Up</strong> if you don't have an account
              </button>
            </SignUpButton>
            </>
          )}
         
          
       
        </motion.div>
      </main>
      
      <style jsx>{`
        .auth-page {
          background: var(--light, #f9f9f9);
          color: var(--text-dark, #333);
          padding: 8rem 2rem;
          min-height: 80vh;
          display: flex;
          justify-content: center;
          align-items: flex-start;
        }
        
        .auth-container {
          max-width: 500px;
          width: 100%;
          background: white;
          border-radius: 15px;
          padding: 2.5rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          text-align: center;
        }
        
        .auth-title {
          font-family: var(--serif, serif);
          font-size: 2rem;
          text-align: center;
          margin-bottom: 1.5rem;
          font-weight: 600;
          color: var(--primary, #6A3EA1);
        }
        
        .redirect-notice {
          text-align: center;
          margin-bottom: 1.5rem;
          color: var(--text-muted, #666);
        }
        
        .error-message {
          background-color: #fef2f2;
          color: #b91c1c;
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-bottom: 1.5rem;
          text-align: center;
        }
        
        .auth-buttons {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-bottom: 2rem;
        }
        
        .clerk-button {
          width: 100%;
          font-size: 1rem;
          font-weight: 600;
          padding: 0.8rem 1.8rem;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .sign-in {
          background: var(--primary, #6A3EA1);
          color: white;
          border: none;
        }
        
        .sign-in:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(106, 62, 161, 0.3);
        }
        
        .sign-up {
          background: white;
          color: var(--primary, #6A3EA1);
          border: 1px solid var(--primary, #6A3EA1);
        }
        
        .sign-up:hover:not(:disabled) {
          background: rgba(106, 62, 161, 0.05);
        }
        
        .clerk-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        
        .loading-container {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .spinner {
          width: 1.25rem;
          height: 1.25rem;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top-color: white;
          border-radius: 50%;
          margin-right: 0.75rem;
          animation: spin 1s linear infinite;
        }
        
        .sign-up .spinner {
          border: 2px solid rgba(106, 62, 161, 0.3);
          border-top-color: var(--primary, #6A3EA1);
        }
        
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        
        .clerk-info {
          margin-top: 2rem;
          padding-top: 1.5rem;
          border-top: 1px solid #e5e7eb;
          font-size: 0.875rem;
          color: #6b7280;
        }
        
        @media (max-width: 768px) {
          .auth-container {
            padding: 1.5rem;
          }
          
          .auth-title {
            font-size: 1.75rem;
          }
        }
      `}</style>
      
      <Footer />
    </div>
  );
} 